var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsertCreditCard = function SvgInsertCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24 3.5C24 1.57 22.43 0 20.5 0h-17C1.57 0 0 1.57 0 3.5c0 1.758 1.308 3.204 3 3.449V19.5C3 21.981 5.019 24 7.5 24h9c2.481 0 4.5-2.019 4.5-4.5V6.949c1.692-.245 3-1.691 3-3.449M8 1h2v22H8zM1 3.5c0-1.207.86-2.217 2-2.449v4.898A2.5 2.5 0 0 1 1 3.5m3 16V1h3v21.949c-1.692-.245-3-1.691-3-3.449m16 0c0 1.93-1.57 3.5-3.5 3.5H11V1h9zm1-13.551V1.051c1.14.232 2 1.242 2 2.449s-.86 2.217-2 2.449M16 17c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 3a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2"
  })));
};
export default SvgInsertCreditCard;